module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/nota-cargo/consultar-eliminar/nota-cargo-consultar.component.scss
// module id = ./src/app/nota-cargo/consultar-eliminar/nota-cargo-consultar.component.scss
// module chunks = main